import React, { useState } from "react";
import {
  Autocomplete,
  Grid,
  Button,
  TextField,
  Box,
  FormControlLabel,
  FormControl,
  Typography,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { table as tablesData } from "../../../constant/filterMenuItems";
import Header from "../../../components/Header";
import axios from "axios";
import { addPermissionAction } from "../../../redux/actions/permissionAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";

const validationSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  // table: yup.string().required("Table is required"),
  isActive: yup.string().required("Select status"),
});

function CreatePermission() {
  // const { loading, user, error } = useSelector(
  //   (state) => state.permissionStore
  // );

  const [formData, setFormData] = useState({
    title: "",
    table: "",
    isActive: "",
  });

  const dispatch = useDispatch();
  const [err, setErr] = useState({});
  const navigate = useNavigate();

  const handleBlur = async (e) => {
    const fieldName = e.target.name;
    try {
      await validationSchema.validateAt(fieldName, formData);
      setErr({ ...err, [fieldName]: "" });
    } catch (error) {
      setErr({ ...err, [fieldName]: error.message });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Manually validate the "table" field
      await validationSchema.validate(
        { ...formData, table: formData.table },
        { abortEarly: false }
      );

      const permissionData = {
        title: formData.title,
        table: formData.table,
        isActive: formData.isActive,
      };

      const success = await dispatch(addPermissionAction(permissionData));
      if (success) {
        toast.success("Permission added successfully");
        navigate("/permission");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error("Failed to add permission");
        navigate("/permission");
        setTimeout(() => {}, 1000);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      // Handle validation errors
      if (error.inner) {
        const errors = {};
        error.inner.forEach((validationError) => {
          errors[validationError.path] = validationError.message;
        });
        setErr(errors);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [selectedValue, setSelectedValue] = useState("");

  return (
    <Box mt="1.5rem" mb="2.5rem" ml="3.5rem" mr="3.5rem">
      <Header title="ADD PERMISSION" />
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth variant="outlined" margin="normal">
          {/* TITLE */}
          <TextField
            label="Title"
            name="title"
            value={formData.title}
            onBlur={handleBlur}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          {err.title && (
            <Grid item>
              <Typography color="error">{err.title}</Typography>
            </Grid>
          )}{" "}
          {/* TABLE */}
          <FormControl fullWidth variant="outlined" margin="normal">
            <Autocomplete
              options={tablesData}
              getOptionLabel={(option) => option.label}
              onChange={(event, value) => {
                if (value && typeof value === "object" && "value" in value) {
                  setFormData({ ...formData, table: value.value });
                } else {
                  setFormData({ ...formData, table: "" });
                }
              }}
              // onBlur={(event) => {
              //   // Validate the table field when the Autocomplete component loses focus
              //   handleBlur(event);
              // }}
              renderInput={(params) => <TextField {...params} label="Table" />}
            />{" "}
            {/* {err.table && (
              <Grid item>
                <Typography color="error">{err.table}</Typography>
              </Grid>
            )}{" "} */}
          </FormControl>
          {/* IS ACTIVE */}
          <FormControl fullWidth variant="outlined" margin="normal">
            <InputLabel>Is Active</InputLabel>
            <Select
              name="isActive"
              value={formData.isActive}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              {/* <MenuItem value="">
                <em>Select</em>
              </MenuItem> */}
              <MenuItem value="true">True</MenuItem>
              <MenuItem value="false">False</MenuItem>
            </Select>
            {err.isActive && (
              <Grid item>
                <Typography color="error">{err.isActive}</Typography>
              </Grid>
            )}{" "}
          </FormControl>
          {/* SUBMIT BUTTON */}
          <Grid container justifyContent="center" alignItems="center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
            >
              Submit
            </Button>
          </Grid>
        </FormControl>
      </form>
    </Box>
  );
}

export default CreatePermission;
